import WsService from "../WsService";
import AgentDocumentType from "../../views/AgentOnBoarding/AgentDocumentTypeResponse";


const ENDPOINT_BASE = "/admin/agent-document-types";

export default class AdminAgentDocumentTypeService {

    static retrieveDocumentTypes() {

        let endpoint = ENDPOINT_BASE;

        return WsService.get(endpoint, {}, 200).then(
            response => {
                let results = [];
                response.forEach(type => {
                        results.push(new AgentDocumentType(type));
                    }
                );
                return results;
            },
            response => {
                return response;
            });
    }

}

